import styled from "styled-components";
import { BREAKPOINTS } from "layout";

export const MainSection = styled.div`
  margin-top: 36px;
`;

export const ImgContainer = styled.div<{ $isDisplayedFirst: boolean }>`
  border-radius: 4px;
  margin: auto;

  order: ${({ $isDisplayedFirst }) => ($isDisplayedFirst ? 0 : 1)};

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    order: 0;
  }
`;

export const Img = styled.img`
  max-width: 766px;
  width: 100%;
  border-radius: 4px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    max-width: unset;
  }
`;

export const ImgCopyContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 36px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    flex-direction: column;
  }
`;

export const Disclaimer = styled.span`
  color: #808893;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const ActionContainer = styled.div`
  margin-top: 36px;
  display: flex;
  justify-content: center;
`;
